<template>
  <component-redirecting/>
</template>

<script>
import ComponentRedirecting from '@/components/default/shared/ComponentRedirecting'

export default {
  components: { ComponentRedirecting },
  name: 'landing',
  mounted () {
    this.redirect()
  },
  methods: {
    redirect () {
      this.$store.dispatch('authUserHandleLandingRedirect')
    }
  }
}
</script>
